import styled from "styled-components";

import { ANIMATION, SPACING } from "../../utils/constants";
import { BaseButton } from "../Button";

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
`;

export const Option = styled(BaseButton)<{
  $selected: boolean;
  $disabled: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.sm}px;
  width: 100%;
  padding: ${SPACING.sm}px ${SPACING.md}px;
  border-radius: ${SPACING.sm}px;
  border: 1px solid
    ${({ $selected }) =>
      $selected ? "var(--color-primary)" : "var(--color-gray-border)"};
  background: ${({ $selected }) =>
    $selected
      ? "var(--color-primary-color-background)"
      : "var(--color-card-background)"};
  color: var(--color-text-default);
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
  text-align: left;
  transition: ${ANIMATION.transitions.all};

  &:hover {
    border-color: ${({ $disabled }) =>
      $disabled ? "var(--color-gray-border)" : "var(--color-primary)"};
  }
`;

export const AccountName = styled.span`
  font-size: var(--text-base);
  font-weight: 500;
`;

export const Check = styled.span<{ $selected: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${SPACING.md}px;
  height: ${SPACING.md}px;
  border-radius: ${SPACING.xs}px;
  border: 1px solid
    ${({ $selected }) =>
      $selected ? "var(--color-primary)" : "var(--color-gray-border)"};
  background: ${({ $selected }) =>
    $selected ? "var(--color-primary)" : "transparent"};
  color: var(--color-white);
  font-size: var(--text-xs);
`;

export const Empty = styled.p`
  font-size: var(--text-sm);
  color: var(--color-text-muted);
  margin: 0;
  padding: ${SPACING.sm}px 0;
`;
